import { Channel, ExportLink, ExportFileFormats, CompressionFormat } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';
import { request } from './request';

export const loadChannels = (search: string, limit: number, offset: number): AxiosPromise<Channel[]> => {
    const { Channels } = request();
    return Channels.channelsGet(search, limit, offset);
};

export const loadSingleChannel = (name: string): AxiosPromise<Channel> => {
    const { Channels } = request();
    return Channels.channelsByNameGet(name);
};

export type ExportChannelsParams = {
    channelNames?: string[];
    fileFormat?: ExportFileFormats;
    compressionFormat?: CompressionFormat;
    fileName?: string;
    allChannels?: boolean;
};

export const exportChannels = (params: ExportChannelsParams): AxiosPromise<ExportLink> => {
    const { Channels } = request();
    const { channelNames, fileFormat, compressionFormat, fileName, allChannels } = params;

    return Channels.channelsTasksExportGet(allChannels, channelNames, fileFormat, compressionFormat, fileName);
};
